import React, { ReactNode } from 'react';
import MediaQuery from '../../../../components-legacy/MediaQuery';
import useSkipHydration from '../../../../hooks/useSkipHydration';
import useToggle from '../../../../hooks/useToggle';
import Panel from '../../../../styled/Panel';
import SquareImage from '../../../../styled/SquareImage';
import { LabelWrapper } from '../../../../styled/PageGrid/product';

interface ILabel {
  image: string;
  name: string;
  panelItem?: ReactNode;
  panelTitle?: string;
}

interface ILabelImage {
  children: ReactNode;
  onClick: (() => void) | undefined;
}

const LabelImage = ({ children, onClick }: ILabelImage) => {
  if (onClick) {
    return (
      <button type="button" onClick={onClick}>
        {children}
      </button>
    );
  }

  return <>{children}</>;
};

const Label = ({ image, name, panelItem, panelTitle }: ILabel) => {
  const [showPanel, toggleShowPanel] = useToggle(false);

  const firstRender = useSkipHydration();

  if (firstRender) {
    return null;
  }

  const altText = name ? `${name} logotyp` : undefined;

  return (
    <>
      {image && (
        <LabelWrapper>
          <LabelImage onClick={panelItem ? toggleShowPanel : undefined}>
            <MediaQuery breakpoint="LtLg">
              <SquareImage
                width="55px"
                height="24px"
                src={image}
                squarePixels={1320}
                alt={altText}
              />
            </MediaQuery>
            <MediaQuery breakpoint="Lg">
              <SquareImage
                width="82.5px"
                height="36px"
                src={image}
                squarePixels={2970}
                alt={altText}
              />
            </MediaQuery>
          </LabelImage>
        </LabelWrapper>
      )}
      {showPanel && panelItem && panelTitle && (
        <Panel title={panelTitle} onClose={toggleShowPanel}>
          {panelItem}
        </Panel>
      )}
    </>
  );
};

export default Label;
